import { CompanyAttributes } from "@/interface/searchTable/search"
import { TRootState } from "@/interface/reduxRoot/state"
import { PayloadAction, createSlice } from "@reduxjs/toolkit"

export type CompanyDetailsState = {
  isOpen: boolean
  company: CompanyAttributes | null
}

const initialState: CompanyDetailsState = {
  isOpen: false,
  company: null
}

const companyDetailsSlice = createSlice({
  name: "companyDetails",
  initialState,
  reducers: {
    openCompanyDetails: (state, action: PayloadAction<CompanyAttributes | null>) => {
      state.isOpen = true
      state.company = action.payload || null
    },
    closeCompanyDetails: (state) => {
      state.isOpen = false
      state.company = null
    }
  }
})

export const { openCompanyDetails, closeCompanyDetails } = companyDetailsSlice.actions

export const selectIsCompanyDetailsOpen = (state: TRootState) => state.companyDetails.isOpen
export const selectCompanyDetails = (state: TRootState) => state.companyDetails.company

export default companyDetailsSlice.reducer
